import {validateAssessmentDefinition} from './assessmentSchema.mjs';
import {validateReportDefinition} from './standardReport.mjs';

export const slugify=value=>String(value||'').toLowerCase().trim().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,70);
export function newAssessment(title='New assessment'){
  const id=slugify(title)||'new-assessment';
  const question={id:'q1',type:'choice',prompt:'How do you manage this process today?',options:['Mostly manual','Partially automated','Mostly automated']};
  return {
    id,shortCode:id.slice(0,24),title,
    intro:'Discover opportunities to improve your operations.',
    description:'Complete a short assessment to receive your personalised PDF report.',
    reportType:'standard',questions:[question],tracking:{},
    report:{type:'standard',version:1,qualification:{grades:[70,40]},
      nextSteps:['Arrange a process review with BPA Solutions.',
        'Explore the improvement opportunities outlined in your report.',
        'Keep reviewing your processes as your business grows.'],
      dimensions:[{questionId:'q1',label:'Process efficiency',maxPoints:25,options:{
        'Mostly manual':{points:0,finding:'This process relies on manual work.',recommendation:'Consider automating routine steps.'},
        'Partially automated':{points:12,finding:'Some tasks are automated.',recommendation:'Connect the remaining manual steps.'},
        'Mostly automated':{points:25,finding:'This process is largely automated.',recommendation:'Review exceptions and reporting controls.'}
      }}]}
  };
}
export function duplicateAssessment(original,slug){
  const id=slugify(slug);
  if(!id||id==='timesheet-to-invoice'||id===original.id)throw new Error('Choose a new unique assessment ID.');
  return {...JSON.parse(JSON.stringify(original)),id,shortCode:id.slice(0,24),
    title:original.title+' (Copy)',enabled:false,publishedVersion:undefined};
}
export function assessDraft(def){
  const errors=validateAssessmentDefinition(def).concat(validateReportDefinition(def));
  if(def.id==='timesheet-to-invoice')errors.push('The legacy Timesheet assessment cannot be overwritten.');
  if(!def.intro?.trim()||!def.description?.trim())errors.push('Intro and description are required.');
  return errors;
}
export function sampleAnswers(assessment){
  return Object.fromEntries(assessment.questions.map(q=>[
    q.id,q.type==='number'?q.min:q.options[0]
  ]));
}
export function replaceOption(assessment,questionId,index,label){
  const next=JSON.parse(JSON.stringify(assessment));
  const question=next.questions.find(q=>q.id===questionId);
  if(!question||question.type!=='choice')throw new Error('Choice question not found.');
  const old=question.options[index];
  if(old===undefined)throw new Error('Choice option not found.');
  question.options[index]=label;
  const dimension=next.report.dimensions.find(d=>d.questionId===questionId);
  if(dimension){
    const rule=dimension.options[old]||{points:0,finding:'Review current process.',recommendation:'Explore improvements.'};
    delete dimension.options[old];
    dimension.options[label]=rule;
  }
  return next;
}
export function addChoice(assessment,questionId){
  const next=JSON.parse(JSON.stringify(assessment));
  const q=next.questions.find(x=>x.id===questionId);
  if(!q||q.type!=='choice'||q.options.length>=30)throw new Error('Cannot add choice.');
  const label='New option '+(q.options.length+1);
  q.options.push(label);
  const dimension=next.report.dimensions.find(d=>d.questionId===questionId);
  if(dimension)dimension.options[label]={points:0,finding:'Add a finding.',recommendation:'Add a recommendation.'};
  return next;
}
export function addQuestion(assessment,type='choice'){
  const next=JSON.parse(JSON.stringify(assessment));
  if(next.questions.length>=30)throw new Error('Question limit reached.');
  let i=1;while(next.questions.some(q=>q.id==='q'+i))i++;
  const id='q'+i;
  if(type==='number')next.questions.push({id,type:'number',prompt:'Enter a number',min:0,max:100,step:1,quickPicks:[10,25,50]});
  else next.questions.push({id,type:'choice',prompt:'New question',options:['Option A','Option B']});
  return next;
}